import BDList from "@component/BDList";
import { VendorApplicationStatus, vendorApplicationStatusMap } from "@page/VendorInfoPage/constant";
import { RootState } from "@redux/rootReducer";
import { fetchVendorList, updateVendorListParams } from "@redux/vendorSlice";
import { Button, Col, DatePicker, Form, Input, Row, Select, Space } from "antd";
import locale from "antd/es/date-picker/locale/zh_TW";
import { Moment } from "moment";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/store";
import styled from "styled-components";

const { RangePicker } = DatePicker;

const Wrapper = styled.div`
  padding: 0 24px;
  margin: 20px 0;
`;
interface FilterValues {
  name?: string;
  ownerId?: number;
  startDateRange?: [Moment | null, Moment | null];
  applicationStatus?: number;
}

const VendorFilter: FC = () => {
  const dispatch = useAppDispatch();
  const { vendorListParams } = useSelector((state: RootState) => state.vendorSlice);
  const [form] = Form.useForm<FilterValues>();

  function handleFinish(values: FilterValues) {
    dispatch(
      updateVendorListParams({
        ...vendorListParams,
        offset: 0,
        name: values.name || undefined,
        ownerId: values.ownerId != null && values.ownerId > 0 ? values.ownerId : undefined,
        startDateAfter: values.startDateRange?.[0] ? values.startDateRange[0].format("YYYY-MM-DD") : undefined,
        startDateBefore: values.startDateRange?.[1] ? values.startDateRange[1].format("YYYY-MM-DD") : undefined,
        applicationStatus: values.applicationStatus ?? undefined,
      }),
    );
    dispatch(fetchVendorList());
  }

  function handleClear() {
    form.resetFields();
    dispatch(updateVendorListParams({ limit: 20, offset: 0 }));
    dispatch(fetchVendorList());
  }

  return (
    <Wrapper>
      <Form form={form} onFinish={handleFinish}>
        <Row gutter={[24, 14]}>
          <Col span={8}>
            <Form.Item label="廠商名稱" name="name">
              <Input placeholder="廠商名稱" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="饌元負責人" name="ownerId">
              <BDList />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="申請狀態" name="applicationStatus">
              <Select style={{ width: 180 }} allowClear placeholder="請選擇">
                {Object.values(VendorApplicationStatus)
                  .filter((v): v is VendorApplicationStatus => typeof v === "number")
                  .map((status) => (
                    <Select.Option key={status} value={status}>
                      {vendorApplicationStatusMap[status]}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 14]} justify="start">
          <Col span={8}>
            <Form.Item label="建立時間" name="startDateRange">
              <RangePicker locale={locale} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="end" style={{ marginTop: 17 }}>
          <Space>
            <Button type="default" size="middle" onClick={handleClear}>
              清除篩選條件
            </Button>
            <Button type="primary" size="middle" htmlType="submit">
              套用
            </Button>
          </Space>
        </Row>
      </Form>
    </Wrapper>
  );
};

export default VendorFilter;
